export default "__VITE_ASSET__e4ecc9bd__"